import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { initI18n } from './app/i18n';
import { autoTranslate } from './app/auto-translate';

initI18n().then(() => {
bootstrapApplication(AppComponent, appConfig).then(() => { 
   setTimeout(() => autoTranslate());
 })
  .catch((err) => console.error(err));
});